import { all, fork } from "@redux-saga/core/effects";
import { rootFlowsSaga } from "./flows";
import { rootComponentsSaga } from "./cxfComponents";
import { rootFlowExecutionSaga } from "./flowExecution";
import { rootCalendarSaga } from "./calendar";
import { rootComponentGroupsSaga } from "./componentGroups";
import { rootUsersSaga } from "./users";
import { rootTenantSaga } from "./tenant";

export default function* rootFlowDesignerSaga() {
  yield all([
    fork(rootFlowsSaga),
    fork(rootComponentsSaga),
    fork(rootFlowExecutionSaga),
    fork(rootCalendarSaga),
    fork(rootComponentGroupsSaga),
    fork(rootUsersSaga),
    fork(rootTenantSaga)
  ]);
}
